import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  FormFieldSet,
  showToast,
  useFormHandler,
} from "../../../../../../components";
import { jobTitleOptions } from "../../../../../../assets/data/projectData";
import { RecordStatus } from "../../../../../../assets/data/enumData";
import { addNewPlacementStart } from "../../../../../../redux/slices/placements/placementsSlice";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";
import { useDispatch, useSelector } from "react-redux";
import { fetchLatestUiid } from "../../../../../../redux/slices/employee/employeeApi";
import { shortenCompanyName } from "../../../../../../utils";
import axiosRequest from "../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../redux/apiConfig";

const JobDetails = ({ setActiveTab, currentPlacement, editData = null, incomingData }) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const [latestPlacementUiid, setLatestPlacementUiid] = useState(null);
  const { employeeProfileUiid, currentEmployee } = useSelector(
    (state) => state.employee,
  );
  const containerRef = useRef(null);
  const [originalData, setOriginalData] = useState([]);
  const [allClientsListOptions, setAllClientsListOptions] = useState([]);
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        billableClient: editData?.jobInfo?.billClient || incomingData?.billableClient || "",
        middleName: "",
        jobTitle: editData?.jobInfo?.jobTitle || incomingData?.jobTitle || "",
        jobStatus: editData?.jobInfo?.status 
          ? { label: editData.jobInfo.status === 1 ? "Active" : "Inactive", value: editData.jobInfo.status } 
          : (incomingData ? { label: "Active", value: 1 } : ""),
        startDate: editData?.jobInfo?.startDate || incomingData?.startDate || "",
        endDate: editData?.jobInfo?.endDate || incomingData?.endDate || "",
        jobCode: editData?.jobInfo?.jobCode || (incomingData?.jobCode ? String(incomingData.jobCode) : ""),
      },
      {
        billableClient: { type: "select", required: true },
        jobCode: { type: "text", required: true },
        jobTitle: { type: "select", required: true },
        jobStatus: { type: "select", required: true },
        startDate: { type: "date", required: true },
        endDate: { type: "date", required: true },
      },
    );
  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const jobInfo = {
        incomingPlacementId: incomingData?.incomingPlacementId,
        billClient: formData?.billableClient?.value ?? formData?.billableClient,
        jobTitle: formData.jobTitle?.value ?? formData.jobTitle,
        status: formData?.jobStatus?.value ?? formData?.jobStatus,
        startDate: formData?.startDate,
        endDate: formData?.endDate,
        jobCode: formData?.jobCode,
      };
      const uiid = fetchPerticularData?.uiid ?? "";
      const submissionData = filterEmptyValues(jobInfo);
      dispatch(
        addNewPlacementStart({
          tPath: "placement",
          rsd: submissionData,
          // rsn: "permanetPlacementJobDetails",
          rsn: `Permanent Placement ${submissionData.jobCode}`,
          ...(uiid && { uiid: uiid }),
          payload: uiid
            ? [
                {
                  type: "SET",
                  value: {
                    type: 2,
                    addedBy: loginUserUiid,
                    employeeId: employeeProfileUiid,
                    jobInfo: { ...submissionData },
                  },
                },
              ]
            : {
                type: 2,
                addedBy: loginUserUiid,
                employeeId: employeeProfileUiid,
                incomingPlacementId: incomingData?.incomingPlacementId,
                jobInfo: { ...submissionData },
              },

          onSuccess: async (payload) => {
            setActiveTab((prev) => prev + 1);
          },
        }),
      );
    } else {
    }
  };
  //  useEffect(() => {
  //     const fetchLatestUiidData = async () => {
  //       try {
  //         const response = await fetchLatestUiid("placements");
  //         //console.log("Latest UIID Data:", response); // For debugging
  //         setLatestPlacementUiid(response.data.data.count + 1); // Modified this line
  //       } catch (error) {
  //         // console.error("Error fetching latest UIID:", error);
  //         showToast("Error fetching latest UIID", "error", 5000);
  //       }
  //     };

  //     fetchLatestUiidData();
  //   }, []);
  useEffect(() => {
    const fetchLatestUiidData = async () => {
      try {
        const response = await fetchLatestUiid("placements");
        const count = response?.data?.data?.count;

        if (typeof count === "number") {
          setLatestPlacementUiid(count + 1);
        } else {
          setLatestPlacementUiid(1);
        }
      } catch (error) {
        // showToast("Error fetching latest UIID", "error", 5000);
        setLatestPlacementUiid(1);
      }
    };

    fetchLatestUiidData();
  }, []);
  // useEffect(() => {
  //     if (formData.billableClient && latestPlacementUiid) {
  //       // Find the selected client's name from the options
  //       const selectedClient = allClientsListOptions.find(
  //         (option) => option.value === formData.billableClient
  //       );

  //       if (selectedClient) {
  //         const clientName = selectedClient.label;
  //         const shortName = shortenCompanyName(clientName);
  //         const newJobCode = `${shortName}-${latestPlacementUiid}`;

  //         // Update the jobCode in the form
  //         setFormData((prevData) => ({
  //           ...prevData,
  //           jobCode: newJobCode,
  //         }));
  //       }
  //     }
  //   }, [formData.billableClient, latestPlacementUiid, allClientsListOptions]);

  const handleChangeUpdateJobCode = (options, data, value) => {
    setAllClientsListOptions(data);
    setOriginalData(options);
    // Find the selected client's name from the options
    const selectedClient = data.find((option) => option.uiid === value);
    if (selectedClient) {
      const newJobCode = `${selectedClient.shortCode}-${String((selectedClient.jobCount || 0) + 1).padStart(3, "0")}`;
      // Update the jobCode in the form
      setFormData((prevData) => ({
        ...prevData,
        jobCode: newJobCode,
      }));
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "jobInfo uiid",
            ref: "Client",
            incl: "uiid businessName",
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          // Optional chaining prevents crashing if values are missing
          handleChange(
            "billableClient",
            data?.jobInfo?.billClient?.businessName
              ? {
                  label: data?.jobInfo?.billClient?.businessName,
                  value: data?.jobInfo?.billClient?.uiid,
                }
              : "",
          );
          handleChange("jobTitle", data?.jobInfo?.jobTitle || "");
          handleChange("jobCode", data?.jobInfo?.jobCode || "");
          handleChange("jobStatus", data?.jobInfo?.status || "");
          handleChange("startDate", data?.jobInfo?.startDate || "");
          handleChange("endDate", data?.jobInfo?.endDate || "");
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);



  return (
    // <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[69vh] overflow-auto">
    <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="grid grid-cols-2 lg:grid-cols-3 max-w-7xl gap-x-8 gap-y-6">
        <div>
          {/* <FormFieldSet
            type="select"
            title={"Billable Client"}
            placeholder="Search for Client "
            value={formData.billableClient}
            onChange={(value) => handleChange("billableClient", value)}
            error={errors.billableClient}
            showSearch
          /> */}
          {/* <FormFieldSet
            type="select"
            title={"Billable Client"}
            keyname={"allClientsList"}
            placeholder="Select Billable Client"
            value={formData.billableClient}
            onChange={(value) => handleChange("billableClient", value)}
            options={allClientsListOptions}
            showSearch
            searchValue={allClientsListSearch}
            onSearch={handleAllClientsListSearch}
            onClose={resetAllClientsListSearch}
            //showButton
            error={errors.billableClient}
            icon={"add"}
            refData={containerRef}
            handleScroll={() => handleAllClientsListScroll(containerRef)}
          /> */}
          <FormFieldSet
            title="Select Client"
            type="allClientsSorted"
            label="DynamicSelect"
            placeholder="Select Client"
            value={formData.billableClient}
            showNames={true}
            // onChange={(e) => setSelectClient(e)}
            onChange={(value) => handleChange("billableClient", value)}
            showSearch
            onSelectItem={
              (options, data, value) => {
                handleChangeUpdateJobCode(options, data, value);
              }
              // handleSelectClientNVender(options, data, value)
            }
          />
        </div>
        <div>
          <FormFieldSet
            type="text"
            title={"Job Code"}
            placeholder="Enter Job Code"
            value={formData.jobCode}
            onChange={(value) => handleChange("jobCode", value)}
            error={errors.jobCode}
            disabled
          />
        </div>
        <div>
          {/* <FormFieldSet
            type="select"
            title={"Job Title"}
            placeholder="Select Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            options={jobTitleOptions}
            showButton
            showSearch
          /> */}
          {/* <FormFieldSet
            type="select"
            title={"Job Title"}
            placeholder="Select Job Title"
            keyname={"jobTitles"}
            options={jobTitleOptions}
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showSearch
            searchValue={jobTitlesSearch}
            onSearch={handleJobTitlesSearch}
            onClose={resetJobTitlesSearch}
            showButton
            alertName={"addJobTitles"}
            icon={"add"}
            required
            handleScroll={() => handleJobTitlesScroll(containerRef)}
            refData={containerRef}
          /> */}
          <FormFieldSet
            type="jobTitle"
            title="Job Title"
            placeholder="Enter Job Title"
            value={formData.jobTitle}
            onChange={(value) => handleChange("jobTitle", value)}
            error={errors.jobTitle}
            showSearch
            showButton
          />
        </div>
        <div>
          <FormFieldSet
            type="select"
            title={"Job Status"}
            placeholder="Select Job Status"
            value={formData.jobStatus}
            onChange={(value) => handleChange("jobStatus", value)}
            error={errors.jobStatus}
            options={RecordStatus}
          />
        </div>
        <div>
          <FormFieldSet
            type="datepicker"
            title={"Start Date"}
            placeholder="Select Start Date"
            value={formData.startDate}
            onChange={(value) => handleChange("startDate", value)}
            error={errors.startDate}
            maxDate={formData.endDate}
            showDropdown={false}
          />
        </div>
        <div>
          <FormFieldSet
            type="datepicker"
            title={"End Date"}
            placeholder="Select End Date"
            value={formData.endDate}
            onChange={(value) => handleChange("endDate", value)}
            error={errors.endDate}
            minDate={formData?.startDate}
            showDropdown={false}
          />
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button title={"Cancel"} variant="outlined" />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default JobDetails;
